export var TIME_TO_SHOW_ERROR_TOAST = 10000;
export var TIME_SLOT_UNAVAILABLE_ERROR_MSG = 'Time slot is no longer available';
export var ERROR_409_MESSAGE = 'Request failed with status code 409';
